<div *ngIf="colours.length > 0" class="base">
    <div class="" *ngIf="!hideVehicleImage">
        <img loading="lazy" class="sidePadding" src="{{imgadd(colours[selected].FileURL, true)}}" onerror="this.classList.toggle('d-none'); this.nextElementSibling.classList.toggle('d-none');" alt="{{colours[selected].Colour}} vehicle image">
        <img loading="lazy" class="sidePadding d-none" src="{{imgadd(colours[selected].FileURL)}}" alt="{{colours[selected].Colour}} vehicle image">
    </div>
    <div class="" *ngIf="hideVehicleImage">
        <h4>Available in these colours</h4>
    </div>
    <div class="cols">
        <div (click)="select(i)" *ngFor="let col of colours; index as i" class="buttonPadding" [ngClass]="selected == i ? 'selectedButton': ''">
            <div class="back"></div>
            <button  [style]="{'background-color':col.HexColour}"></button>
        </div>
    </div>
    <div>
    <h5 *ngIf="!hideColourName">Colour: {{colours[selected].Colour}}</h5>
    </div>
</div>
